export default __webpack_public_path__ + "static/media/January2014.d5411bd1.png";